import banner_General from './images.jpg';
import banner_Keychain from './banner_Keychain.jpg';
import banner_Pen from './banner_Pen.jpg';
import banner_Candle_holders from './banner_Candle_holders.jpg';


let Description_ShopCategory = [
    {
        category: 'General',
        images: banner_General,
        description: 'За кожним виробом нашої майстерні — унікальна історія. Її серце — це майстер. Він — не просто ремісник, а справжній фанат зброї, офіцер, професійний військовий у минулому. Його життя круто змінилося після втрати зору — важке випробування, яке не зламало духу, а лише загартувало характер. Сьогодні він творить унікальні речі зі своєю особливою енергією — брелки для ключів, ручки та підсвічники з використаних гільз та куль. Кожен виріб — це не просто аксесуар, а символ сили, витримки та трансформації. Те, що колись було частиною зброї — сьогодні перетворюється на витвір мистецтва, зроблений руками людини, яка не зламалася і знайшла новий сенс у творчості. Ці вироби — не просто прикраси чи предмети інтер’єру. Вони — історія, яка живе в металі. Вони — пам’ять, перетворена в красу. Вони — нагадування, що навіть після найтемнішого періоду можна створювати світло.',

    },
    {
        category: 'Keychain',
        images: banner_Keychain,
        description: 'Брелки для ключів з використаних гільз та куль — це не просто аксесуари, а справжні мініатюрні витвори мистецтва з характером. Кожен брелок виготовлений вручну з використаних гільз та куль різних калібрів, що додає йому унікальності та історії. Такий виріб ідеально підходить для поціновувачів військової тематики, стилю мілітарі, мисливців або просто тих, хто цінує оригінальні речі. Відмінно виглядає на зв’язці ключів, рюкзаку чи в авто.',

    },
    {
        category: 'Pen',
        images: banner_Pen,
        description: 'Унікальна ручка з гільз — це більше, ніж просто засіб для письма. Виготовлена вручну, кожен елемент несе в собі частинку історії та символізує силу, стійкість і характер. Така ручка стане не лише функціональним аксесуаром, а ідеальним подарунком для військових, колекціонерів або поціновувачів унікальних речей.',

    },
    {
        category: 'Candle_holders',
        images: banner_Candle_holders,
        description: 'Унікальний підсвічник ручної роботи, створений з бойових елементів — це справжній витвір мистецтва, що поєднує силу металу й тепло вогню. Кожна деталь має свій характер, а композиція вражає оригінальністю. Ідеальний подарунок або акцент для інтерʼєру, що не залишить байдужим.',

    },
]

export default Description_ShopCategory;